<script>
export default {
    name: 'IconInstagram'
}
</script>
<template>
    <svg
        class="base-icon icon-instagram"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor" fill-rule="evenodd" d="M32.006 17.642A14.333 14.333 0 0 0 17.652 32a14.333 14.333 0 0 0 14.354 14.358c7.946 0 14.355-6.41 14.355-14.358a14.333 14.333 0 0 0-14.355-14.358zm0 23.692c-5.134 0-9.332-4.186-9.332-9.334s4.185-9.334 9.332-9.334c5.147 0 9.333 4.186 9.333 9.334s-4.198 9.334-9.333 9.334zm18.29-24.279a3.34 3.34 0 0 1-3.348 3.349 3.34 3.34 0 0 1-3.348-3.349 3.349 3.349 0 1 1 6.696 0zm9.507 3.399c-.212-4.486-1.237-8.46-4.522-11.734-3.273-3.274-7.246-4.298-11.731-4.523-4.623-.263-18.477-.263-23.1 0-4.472.212-8.445 1.237-11.73 4.51-3.286 3.275-4.298 7.248-4.523 11.734-.263 4.624-.263 18.482 0 23.105.212 4.486 1.237 8.46 4.522 11.734 3.286 3.274 7.246 4.298 11.731 4.523 4.623.263 18.477.263 23.1 0 4.485-.212 8.458-1.237 11.73-4.523 3.274-3.274 4.298-7.248 4.523-11.734.263-4.623.263-18.469 0-23.092z"
        />
    </svg>
</template>
